import React from "react";
import ReactDOM from "react-dom";
import Store from "./Store";
// import "./styles-others.css";

const noop = () => {}

if (process.env.NODE_ENV !== "development" ) {
  //console.log = noop;
}

ReactDOM.render(<Store></Store>, document.getElementById("root"));
